import { Box, styled } from '@mui/material';
import TabContent from '../../atoms/tab/TabContent';
import Title from '../../atoms/title/Title';
import HpTooltip from '../../atoms/tooltip/HpTooltip';
import { ITabContentProps } from '../../commons/types';
import Button from '../../atoms/button/Button';
import SubTitle from '../../atoms/title/SubTitle';
import ResetButton from '../../atoms/button/ResetButton';
import LevelsVLTable from '../../organisms/tables/VariableLibrary/LevelsVLTable';
import { useRef } from 'react';
import { MRT_TableInstance } from 'material-react-table';
import { useActions } from '../../hooks/actions';
import { LevelVLModal } from '../../organisms/modals/VariableLibrary/LevelVLModal';
import { useGetLevelsListQuery } from '../../store/api/leadership';

const StyledTitlesWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const StyledTitleWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const StyledHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const StyledSubHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const StyledHeaderActionWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  gap: '15px',
});

const Levels = ({ index, value }: ITabContentProps) => {
  const { data: { data } = {}, isLoading } = useGetLevelsListQuery('Master');

  const { openAddLevelVLModal } = useActions();

  const tableInstanceRef = useRef<MRT_TableInstance>(null);

  const onResetButtonClick = (): void => {
    tableInstanceRef.current !== null &&
      tableInstanceRef.current.resetColumnFilters();
  };

  return (
    <TabContent
      index={index}
      value={value}
    >
      <StyledTitlesWrapper>
        <StyledTitleWrapper>
          <StyledHeaderWrapper>
            <Title
              text={'Levels'}
              sx={{
                fontSize: '28px',
              }}
            />
            <Box>
              <HpTooltip title={' '} />
            </Box>
          </StyledHeaderWrapper>
          <StyledHeaderActionWrapper>
            <Button
              btnType={'PRIMARY'}
              text={'Add new level'}
              onClick={() => openAddLevelVLModal()}
            />
          </StyledHeaderActionWrapper>
        </StyledTitleWrapper>
        <StyledSubHeaderWrapper>
          <SubTitle
            text={`${data?.length ? data?.length : '0'} total levels`}
          />
          <ResetButton
            onClick={onResetButtonClick}
            text='Reset'
          />
        </StyledSubHeaderWrapper>
      </StyledTitlesWrapper>
      <LevelsVLTable
        data={data}
        isLoading={isLoading}
        tableInstanceRef={tableInstanceRef}
      />
      <LevelVLModal />
    </TabContent>
  );
};

export default Levels;
